import React, { useId } from "react";

/**
 * Ícone oficial de TAREFAS: folha com itens de checklist e uma lupa com "check"
 * (tarefa conferida). Usar sempre que a tela representar o conceito de tarefa
 * [USR, 2026-10-07] — o usuário deve associar este ícone à função de tarefas.
 *
 * Mesma assinatura dos ícones do react-icons (`size`, `className`, `style` e
 * qualquer prop de <svg>): sem `size`, ocupa 1em e herda cor (`currentColor`) e
 * tamanho do texto, então funciona em botões, menus e chips.
 */
export default function TaskIcon({ size = "1em", strokeWidth = 1.8, ...rest }) {
  // A lupa "recorta" o traçado da folha por baixo dela; o id da máscara precisa
  // ser único por instância (vários ícones na mesma tela).
  const maskId = `task-icon-mask-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#fff" stroke="none" />
        <circle cx="16.2" cy="16.2" r="5.3" fill="#000" stroke="none" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <rect x="3" y="2.5" width="14.5" height="19" rx="1.8" />
        <rect x="5.6" y="5.2" width="2.8" height="2.8" rx="0.6" />
        <line x1="10.5" y1="6.6" x2="14.8" y2="6.6" />
        <rect x="5.6" y="9.7" width="2.8" height="2.8" rx="0.6" />
        <line x1="10.5" y1="11.1" x2="14.8" y2="11.1" />
        <rect x="5.6" y="14.2" width="2.8" height="2.8" rx="0.6" />
        <line x1="10.5" y1="15.6" x2="12" y2="15.6" />
      </g>
      <circle cx="16.2" cy="16.2" r="3.9" />
      <path d="M14.3 16.3l1.4 1.4 2.6-2.9" />
      <line x1="19.1" y1="19.1" x2="21.6" y2="21.6" />
    </svg>
  );
}
